export const TENCENT_MODELS = [ '3.0', '3.1' ];
export const TENCENT_GENERATE_TYPES = [ 'Normal', 'LowPoly', 'Geometry', 'Sketch' ];
export const TENCENT_POLYGON_TYPES = [ 'triangle', 'quadrilateral' ];
export const TENCENT_FACE_COUNT_MIN = 3000;
export const TENCENT_FACE_COUNT_MAX = 1500000;

export const TENCENT_DEFAULTS = {
  model: '3.0',
  enablePBR: false,
  faceCount: 500000,
  generateType: 'Normal',
  polygonType: 'triangle',
};

const isGenerateTypeAllowedForModel = (generateType, model) => {
  if (model === '3.1') {
    return generateType !== 'LowPoly' && generateType !== 'Sketch';
  }
  return true;
};

export const buildTencentProperties = settings => {
  const { model, enablePBR, faceCount, generateType, polygonType } = settings;
  const properties = {
    model,
    faceCount: Number(faceCount),
    generateType,
  };

  if (generateType !== 'Geometry') {
    properties.enablePBR = enablePBR;
  }
  if (generateType === 'LowPoly') {
    properties.polygonType = polygonType;
  }

  return properties;
};

export const validateTencentSettings = settings => {
  const errors = {};
  const { model, faceCount, generateType, polygonType } = settings;

  if (!TENCENT_MODELS.includes(model)) {
    errors.model = 'Invalid model.';
  }

  const numericFaceCount = Number(faceCount);
  if (!Number.isFinite(numericFaceCount)
    || numericFaceCount < TENCENT_FACE_COUNT_MIN
    || numericFaceCount > TENCENT_FACE_COUNT_MAX) {
    errors.faceCount = `Face count must be between ${TENCENT_FACE_COUNT_MIN} and ${TENCENT_FACE_COUNT_MAX}.`;
  }

  if (!TENCENT_GENERATE_TYPES.includes(generateType)) {
    errors.generateType = 'Invalid generate type.';
  } else if (!isGenerateTypeAllowedForModel(generateType, model)) {
    errors.generateType = `"${generateType}" is not available when model is "3.1".`;
  }

  if (!TENCENT_POLYGON_TYPES.includes(polygonType)) {
    errors.polygonType = 'Invalid polygon type.';
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
